<script setup lang="ts">
const colorMode = useColorMode();

const toggleTheme = () => {
  colorMode.preference = colorMode.preference === "dark" ? "light" : "dark";
};
</script>

<template>
  <ClientOnly>
    <button
      @click="toggleTheme"
      class="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
      aria-label="Toggle theme"
    >
      <Icon
        :name="colorMode.value === 'dark' ? 'heroicons:moon' : 'heroicons:sun'"
        class="w-5 h-5 text-gray-700 dark:text-gray-300"
      />
    </button>
  </ClientOnly>
</template>
